<template>
  <div align="center">
    <v-alert>
      No se han encontrado resultados...
    </v-alert>
    <div align="center">
      <v-img
        center
        contain
        lazy-src="https://res.cloudinary.com/capital28-investments/image/upload/v1640032741/Capital%2028/Common/no_result_lead.png"
        max-height="500"
        max-width="375"
        src="https://res.cloudinary.com/capital28-investments/image/upload/v1640032741/Capital%2028/Common/no_result_lead.png"
      >
      </v-img>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewError"
};
</script>
